export const formatUtils = {
    fixText: (string: string) => {
        const newString: string = String(string);
        let str: string = newString.toLowerCase();
        for (let i = 0; i < str.length; i += 1) {
            if (str.charAt(i) === 'á') str = str.replace(/á/, 'a');
            if (str.charAt(i) === 'é') str = str.replace(/é/, 'e');
            if (str.charAt(i) === 'í') str = str.replace(/í/, 'i');
            if (str.charAt(i) === 'ó') str = str.replace(/ó/, 'o');
            if (str.charAt(i) === 'ú') str = str.replace(/ú/, 'u');
            if (str.charAt(i) === 'ñ') str = str.replace(/ñ/, 'n');
        }
        return str;
    }
};